<!-- Sem `windowMode`: ele recua o topo e limita a largura, e era isso que deixava faixas
     vazias em volta da tela de entrada. -->
<nb-layout class="login-neb-layout">
  <nb-layout-column class="login-neb-column">
<div class="login-page">
  <!-- Interior de igreja católica gerado para o projeto -->
  <div class="login-bg-photo" aria-hidden="true"></div>
  <div class="login-bg-veil" aria-hidden="true"></div>

  <div class="login-centro">
    <div class="login-marca">
      <div class="login-logo-frame">
        <img src="assets/domus-data-logo.png?v=2" alt="DOMUS DATA" class="login-logo" />
      </div>
      <p class="login-marca-sub">Gestão catequética · Eclesial</p>
    </div>

    <nb-card class="login-card">
      <nb-card-body class="login-card-body">
        <ng-container *ngIf="modo === 'entrar'; else recuperar">
        <div class="login-card-intro">
          <h1 class="login-titulo">Entrar</h1>
          <p class="login-sub">Acesse o painel com seu usuário e senha</p>
        </div>

        <div class="login-fields">
          <label class="login-label" for="campo-login">Login</label>
          <input
            nbInput
            fullWidth
            fieldSize="large"
            id="campo-login"
            type="text"
            [(ngModel)]="login"
            (keyup.enter)="entrar()"
            autocomplete="username"
            placeholder="Seu usuário"
          />

          <label class="login-label" for="campo-senha">Senha</label>
          <input
            nbInput
            fullWidth
            fieldSize="large"
            id="campo-senha"
            type="password"
            [(ngModel)]="senha"
            (keyup.enter)="entrar()"
            autocomplete="current-password"
            placeholder="••••••••"
          />

          <button
            nbButton
            fullWidth
            status="primary"
            size="large"
            class="login-btn"
            [disabled]="carregando"
            [nbSpinner]="carregando"
            nbSpinnerSize="tiny"
            nbSpinnerStatus="control"
            (click)="entrar()"
          >
            {{ carregando ? 'Entrando…' : 'Acessar painel' }}
          </button>

          <button type="button" class="login-link" (click)="abrirRecuperacao()">
            Esqueci minha senha
          </button>
        </div>
        </ng-container>

        <ng-template #recuperar>
          <div class="login-card-intro">
            <h1 class="login-titulo">Recuperar senha</h1>
            <p class="login-sub">
              Informe seu login. Se ele estiver cadastrado, você recebe um e-mail com o link para
              definir uma senha nova.
            </p>
          </div>

          <div class="login-fields" *ngIf="!mensagemRecuperacao; else pedidoEnviado">
            <label class="login-label" for="campo-login-recuperar">Login</label>
            <input
              nbInput
              fullWidth
              fieldSize="large"
              id="campo-login-recuperar"
              type="text"
              [(ngModel)]="login"
              (keyup.enter)="enviarRecuperacao()"
              autocomplete="username"
              placeholder="Seu e-mail"
            />

            <!-- Regra da API: pedido feito, o login fica bloqueado até a senha nova ser
                 definida pelo link. Quem lê isso antes decide se quer mesmo pedir. -->
            <p class="login-aviso">
              Depois do pedido, o acesso com a senha atual fica bloqueado até você definir a senha
              nova pelo link do e-mail.
            </p>

            <button
              nbButton
              fullWidth
              status="primary"
              size="large"
              class="login-btn"
              [disabled]="enviandoRecuperacao"
              [nbSpinner]="enviandoRecuperacao"
              nbSpinnerSize="tiny"
              nbSpinnerStatus="control"
              (click)="enviarRecuperacao()"
            >
              {{ enviandoRecuperacao ? 'Enviando…' : 'Enviar link' }}
            </button>

            <button type="button" class="login-link" (click)="voltarParaEntrar()">
              Voltar para o login
            </button>
          </div>

          <ng-template #pedidoEnviado>
            <div class="login-fields">
              <p class="login-confirmacao" role="status">{{ mensagemRecuperacao }}</p>
              <button type="button" class="login-link" (click)="voltarParaEntrar()">
                Voltar para o login
              </button>
            </div>
          </ng-template>
        </ng-template>
      </nb-card-body>
    </nb-card>

    <p class="login-rodape">DOMUS DATA</p>
  </div>
</div>
  </nb-layout-column>
</nb-layout>
